import React from 'react';
import styled from 'styled-components';

type DataType = {
  title?: string;
  id?: number;
};

type Props = {
  handleTabClick?: (e: any) => void;
  defaultData?: DataType[];
  className?: string;
  activeTab?: number;
};

export const TabComponetMobile = ({
  handleTabClick,
  defaultData,
  className,
  activeTab,
}: Props) => {
  const [textAreaData, setTextAreaData] = React.useState<number | undefined>(1);

  const onTabClick = (item: DataType) => {
    handleTabClick?.(item);
  };

  React.useEffect(() => {
    setTextAreaData(activeTab);
  }, [activeTab]);

  return (
    <MainWrapper className={className ?? ''}>
      <UlWrapper className="ul-wrapper">
        {defaultData?.map(
          item =>
            item.title && (
              <LiWrapper
                key={item.id}
                className={`${item.id === textAreaData ? 'active' : ''}`}
                onClick={() => onTabClick(item)}
              >
                <span>{item.title}</span>
              </LiWrapper>
            ),
        )}
      </UlWrapper>
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  width: 100%;
`;
const UlWrapper = styled.ul`
  display: flex;
  justify-content: space-between;
  padding: 0;
  list-style: none;
  border-bottom: 5px solid ${p => p.theme.tabBorderClr};
`;

const LiWrapper = styled.li`
  display: inline-flex;
  font-family: 'Open Sans';
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: ${p => p.theme.tabTextClr};
  position: relative;
  cursor: pointer;

  &.active {
    color: ${p => p.theme.black};
    font-weight: 700;
    font-family: 'Open Sans';
  }

  span {
    display: inline-flex;
    white-space: nowrap;
    position: relative;
    padding: 15px 0;
    height: 100%;
  }

  &.active span {
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      width: 100%;
      height: 5px;
      background-color: ${p => p.theme.black};
      border-radius: 10px;
      left: 0;
    }
  }

  /* Apply different text-align for specific items */
  &:nth-child(1) {
    text-align: center;
  }

  &:nth-child(2) {
    text-align: center;
  }

  &:nth-child(3) {
    text-align: center;
  }
`;
